import { create } from 'zustand';

interface UIStore {
  // Modal states
  isUploadDialogOpen: boolean;
  uploadDialogProjectId: number | null;
  isMergeDialogOpen: boolean;
  isDeleteConfirmOpen: boolean;
  isDedupDialogOpen: boolean;
  dedupFileId: string | null;

  // Loading states
  isGlobalLoading: boolean;
  loadingMessage: string | null;

  // Notifications
  notification: {
    type: 'success' | 'error' | 'info' | 'warning';
    message: string;
  } | null;

  // Actions
  openUploadDialog: (projectId?: number) => void;
  closeUploadDialog: () => void;
  openMergeDialog: () => void;
  closeMergeDialog: () => void;
  openDeleteConfirm: () => void;
  closeDeleteConfirm: () => void;
  openDedupDialog: (fileId: string) => void;
  closeDedupDialog: () => void;

  setGlobalLoading: (loading: boolean, message?: string) => void;
  showNotification: (type: 'success' | 'error' | 'info' | 'warning', message: string) => void;
  clearNotification: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  // Initial state
  isUploadDialogOpen: false,
  uploadDialogProjectId: null,
  isMergeDialogOpen: false,
  isDeleteConfirmOpen: false,
  isDedupDialogOpen: false,
  dedupFileId: null,
  isGlobalLoading: false,
  loadingMessage: null,
  notification: null,

  // Modal actions
  openUploadDialog: (projectId?: number) => set({ isUploadDialogOpen: true, uploadDialogProjectId: projectId ?? null }),
  closeUploadDialog: () => set({ isUploadDialogOpen: false, uploadDialogProjectId: null }),
  openMergeDialog: () => set({ isMergeDialogOpen: true }),
  closeMergeDialog: () => set({ isMergeDialogOpen: false }),
  openDeleteConfirm: () => set({ isDeleteConfirmOpen: true }),
  closeDeleteConfirm: () => set({ isDeleteConfirmOpen: false }),
  openDedupDialog: (fileId: string) => set({ isDedupDialogOpen: true, dedupFileId: fileId }),
  closeDedupDialog: () => set({ isDedupDialogOpen: false, dedupFileId: null }),

  // Loading actions
  setGlobalLoading: (loading, message) =>
    set({ isGlobalLoading: loading, loadingMessage: message || null }),

  // Notification actions
  showNotification: (type, message) => set({ notification: { type, message } }),
  clearNotification: () => set({ notification: null }),
}));
